import { writable } from 'svelte/store';

// Create persistent stores
export const firstInfoCache = writable(new Map());
export const appInfoCache = writable(new Map());
export const appDeviceCache = writable(new Map()); 